import { render, staticRenderFns } from "./GamificationsForm.vue?vue&type=template&id=058ac564&"
import script from "./GamificationsForm.vue?vue&type=script&lang=js&"
export * from "./GamificationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports